<template>
  <div class="tcdc-menu-divider"></div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.tcdc-menu-divider {
  border-bottom: 2px solid white;
}
</style>
